// components/LogoutButton.jsx
import React ,{ useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton ,Tooltip} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { clearCache } from './CacheHandler';
import { ModeContext } from './ModeContext';
import { useMsal } from '@azure/msal-react';

const ButtonLogout = () => {
  const { 
    setLoginInfo, 
    sessionId, 
    setSessionId,
    setMessages,
    setChatHistory,
    setIsComplete,
    setIsUploadMode,
    setSelectedFiles,
    setSelectedFile,
    setFileList,
    setActiveButton,
    setUser,
    setDataset,
    setInput,
    setFilebuList,
    setDisplayMode,
    setRequestStatusFilter,
    setRequestStatusCounts,
    setFaqList,
    setUnreadCommentCount,
    setMode
  } = useContext(ModeContext);
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // 入力履歴を保存（削除前に退避）
      const compIdHistory = localStorage.getItem('compIdHistory');
      const userIdHistory = localStorage.getItem('userIdHistory');

      // localStorageをすべてクリア
      localStorage.clear();

      // 入力履歴を復元
      if (compIdHistory) localStorage.setItem('compIdHistory', compIdHistory);
      if (userIdHistory) localStorage.setItem('userIdHistory', userIdHistory);

      // sessionStorageもクリア
      sessionStorage.clear();

      // Context状態をすべてリセット
      setSessionId('');
      setMessages([]);
      setChatHistory([]);
      setIsComplete(true);
      setIsUploadMode(false);
      setSelectedFiles([]);
      setSelectedFile([]);
      setFileList([]);
      setActiveButton('chat');
      setUser('');
      setDataset({});
      setInput('');
      setFilebuList('');
      setDisplayMode('chat');
      setRequestStatusFilter('');
      setRequestStatusCounts({});
      setFaqList([]);
      setUnreadCommentCount(0);
      setMode('');
      setLoginInfo({ isLoggedIn: false });

      // キャッシュクリア
      await clearCache();

      // Microsoft SSOのセッションもクリア
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        await instance.logoutPopup({
          account: accounts[0],
          postLogoutRedirectUri: window.location.origin + '/login'
        });
      }

      console.log("ログアウトしました。");

      // ログインページにリダイレクト
      navigate('/login');
    } catch (error) {
      console.error('ログアウト処理中にエラーが発生しました:', error);
      // エラーが発生してもログインページにリダイレクト
      navigate('/login');
    }
  };

  return (
    <Tooltip title="ログアウト">
      <IconButton
        onClick={handleLogout}
        sx={{
          bgcolor: "#777777",
          color: "white",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
        }}
      >
        <LogoutIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ButtonLogout;
